import React from "react";
import CustomDialogue from "../CustomDialogue";
import { ModalConfig } from "../../hooks/useModal";
import AddCode from "../AddCode";

type Props = {
  modalConfig: ModalConfig;
};

const AddCodeModal = ({ modalConfig }: Props) => {
  return (
    <CustomDialogue modalConfig={modalConfig}>
      <AddCode />
    </CustomDialogue>
  );
};

export default AddCodeModal;
